import { CheckCircledIcon, MinusCircledIcon } from '@radix-icons/vue'
import { h } from 'vue'

const toastMessage = (pageName: string) => {
  return {
    DeleteSuccess: {
      Msg: `Xóa ${pageName} thành công!`,
      Type: 'success'
    },
    DeleteWarning: {
      Msg: `Không có ${pageName} nào được chọn!`,
      Type: 'warning'
    },
    DeleteError: {
      Msg: `Xóa ${pageName} thất bại!`,
      Type: 'error'
    },
    AddNewSuccess: {
      Msg: `Thêm ${pageName} thành công!`,
      Type: 'success'
    },
    EditSuccess: {
      Msg: `Sửa ${pageName} thành công!`,
      Type: 'success'
    },
    EditWarning: {
      Msg: `Không có ${pageName} nào được chọn!`,
      Type: 'warning'
    }
  }
}

const actionsType = (pageName?: string) => {
  return {
    AddNew: {
      Title: `Thêm ${pageName}`,
      Type: 'addNew'
    },
    Edit: {
      Title: `Sửa ${pageName}`,
      Type: 'edit'
    },
    Delete: {
      Title: `Xóa ${pageName}`,
      Type: 'delete'
    },
    DeleteMultiple: {
      Title: `Xóa nhiều ${pageName}`,
      Type: 'delete-multiple'
    },
    Default: {
      Title: 'Không có hành động nào được thực hiện',
      Type: 'default'
    }
  }
}

const toastConfirmMsg = (pageName: string, id?: string) => {
  return {
    Delete: {
      Title: 'Xác nhận xóa',
      Msg: `Bạn có chắc chắn muốn xóa <b>${pageName}</b>${id ? ' với Mã: <b>' + id + '</b>' : ''}?`
    },
    DeleteMultiple: {
      Title: 'Xác nhận xóa nhiều',
      Msg: `Bạn có chắc chắn muốn xóa tất cả <b>${pageName}</b> đang chọn?`
    }
  }
}

const pageSizes = [10, 25, 50, 100]

const ActionPerms: { [index: string]: any } = {
  None: {
    name: 'Không',
    icon: '',
    value: 0
  },
  View: {
    name: 'Xem',
    icon: (
      <svg
        class="text-blue-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="3"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>
    ),
    value: 1
  },
  Add: {
    name: 'Thêm',
    icon: (
      <svg
        class="text-green-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="3"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 4v18m9-9h-18" />
      </svg>
    ),
    value: 2
  },
  Edit: {
    name: 'Sửa',
    icon: (
      <svg
        class=" text-yellow-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        />
      </svg>
    ),
    value: 4
  },
  Delete: {
    name: 'Xóa',
    icon: (
      <svg
        class="text-red-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="3"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
      </svg>
    ),
    value: 8
  },
  Import: {
    name: 'Nhập Excel',
    icon: (
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          d="M3 8V5.828a2 2 0 0 1 .586-1.414l2.828-2.828A2 2 0 0 1 7.828 1h8.239A.969.969 0 0 1 17 2v16a.969.969 0 0 1-.933 1H3.933A.97.97 0 0 1 3 18v-2M8 1v4a1 1 0 0 1-1 1H3m-2 6h10M9.061 9.232 11.828 12l-2.767 2.768"
        />
      </svg>
    ),
    value: 16
  },
  Export: {
    name: 'Xuất Excel',
    icon: (
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 6V2a.97.97 0 0 0-.933-1H5.828a2 2 0 0 0-1.414.586L1.586 4.414A2 2 0 0 0 1 5.828V18a.969.969 0 0 0 .933 1H14a1 1 0 0 0 1-1M6 1v4a1 1 0 0 1-1 1H1m6 6h9m-1.939-2.768L16.828 12l-2.767 2.768"
        />
      </svg>
    ),
    value: 32
  }
}

export const status = {
  Active: {
    Title: 'Hoạt động',
    Value: 1
  },
  Deactivate: {
    Title: 'Ngưng Hoạt động',
    Value: 0
  }
}

export const deleteStatus = {
  NotDeleted: {
    Title: 'Sẵn sàng',
    Value: 0
  },
  Deleted: {
    Title: 'Đã xóa',
    Value: 1
  }
}

export const gender = {
  Male: {
    Name: 'Nam',
    Value: 0
  },
  Female: {
    Name: 'Nữ',
    Value: 1
  },
  Other: {
    Name: 'Khác',
    Value: 2
  }
}

export const statuses = [
  {
    label: status.Active.Title,
    value: status.Active.Value,
    icon: h(CheckCircledIcon),
    class: 'text-[#50B83C]'
  },
  {
    label: status.Deactivate.Title,
    value: status.Deactivate.Value,
    icon: h(MinusCircledIcon),
    class: 'text-red-500'
  }
]

export const deleteStatuses = [
  {
    label: deleteStatus.NotDeleted.Title,
    value: deleteStatus.NotDeleted.Value,
    icon: h(CheckCircledIcon),
    class: 'text-[#50B83C]'
  },
  {
    label: deleteStatus.Deleted.Title,
    value: deleteStatus.Deleted.Value,
    icon: h(MinusCircledIcon),
    class: 'text-red-500'
  }
]

export const genders = [
  {
    label: gender.Male.Name,
    value: gender.Male.Value
  },
  {
    label: gender.Female.Name,
    value: gender.Female.Value
  },
  {
    label: gender.Other.Name,
    value: gender.Other.Value
  }
]

export const actionsFooter = {
  Help: {
    Name: 'Giúp',
    Icon: 'icon-help'
  },
  Add: {
    Name: 'Thêm mới',
    Icon: 'icon-add'
  },
  AddAndRenew: {
    Name: 'Lưu và Thêm',
    Icon: 'icon-add-renew'
  },
  Edit: {
    Name: 'Xác nhận',
    Icon: 'icon-edit'
  },
  Cancel: {
    Name: 'Hủy bỏ',
    Icon: 'icon-cancel'
  }
}

export const FeePayer = {
  Shop: 1,
  Buyer: 2
}

export const defaultPageId = '00000000-0000-0000-0000-000000000000'

export { toastMessage, actionsType, toastConfirmMsg, pageSizes, ActionPerms }
